/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class Breadcrumb extends Component {
  // passed in
  backRoute = null;

  backLabel = null;
  current = null;
  onBack = null; // optional action; if provided, renders a button instead of a link
}
